"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.contact = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
exports.contact = joi_1.default.object({
    preferredLanguageCode: (_a = joi_1.default.number()).valid.apply(_a, Object.values(constants_1.Language)).required(),
    phoneNumber: joi_1.default.string()
        .regex(/^[0-9]*$/)
        .min(10)
        .max(10)
        .optional()
        .allow('')
        .messages({
        'string.pattern.base': constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY, 'Phone Number'),
    }),
    firstName: joi_1.default.string()
        .regex(/^[a-zA-ZÀ-ÿ- ]*$/)
        .min(1)
        .max(15)
        .required()
        .messages({
        'string.pattern.base': constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_ALHPABETS_AND_DASHES_ONLY, 'First Name'),
    }),
    lastName: joi_1.default.string()
        .regex(/^[a-zA-ZÀ-ÿ- ]*$/)
        .min(1)
        .max(25)
        .required()
        .messages({
        'string.pattern.base': constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_ALHPABETS_AND_DASHES_ONLY, 'Last Name'),
    }),
    extensionPhoneNumber: joi_1.default.string()
        .regex(/^[0-9]*$/)
        .min(0)
        .max(5)
        .optional()
        .allow('')
        .messages({
        'string.pattern.base': constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY, 'Extension Phone Number'),
    }),
    faxNumber: joi_1.default.string()
        .regex(/^[0-9]*$/)
        .min(0)
        .max(10)
        .optional()
        .allow('')
        .messages({
        'string.pattern.base': constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY, 'Fax Number'),
    }),
});
